export interface IReplaceCounter {
    countNeedReplace?: number;
    countNeedAccept?: number;
}

export class ReplaceCounter implements IReplaceCounter {
    constructor(
        public countNeedReplace: number,
        public countNeedAccept: number
    ) {}
    
}
  